import { render, staticRenderFns } from "./edit-product.vue?vue&type=template&id=429afa64&scoped=true&"
import script from "./edit-product.vue?vue&type=script&lang=js&"
export * from "./edit-product.vue?vue&type=script&lang=js&"
import style0 from "./edit-product.vue?vue&type=style&index=0&id=429afa64&scoped=true&lang=css&"
import style1 from "./edit-product.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429afa64",
  null
  
)

export default component.exports